// import { toast } from 'react-toastify';
import {
  additionalFields,
  getAgentList,
  getAgentListEvalution,
  getTeamList,
  getTeamListEvalution,
  getTeamListAnalytics,
  getAgentListAnalytics,
  getAgentListAnalyze,
  getTeamListAnalyze,
  getDataFromStore,
  getDataFromUserStore,
  getDataFromCategoryStore,
  getTeamListcallFlow,
  getAgentListCallflow,
  // objectToArray,
  // sortByPriorityIndex,
  // convertdataDashbordfilter,
  getTeamListdashbord,
  getAgentListdashbord,
  getAgentListDataByIds,
  getTeamListDataByIds
} from 'utils/redux';
// import { getEvalutionsData } from '../Evalution';
import { getReportingTeamColumnData, handleLobFilterChange } from 'store/ScoreCardFilter';
import { extractData } from 'utils/Sidebar';
import { getConversationData } from 'store/FeedBack';
import { getUnreadNotificationsData } from 'store/Notifications';
import { getReportingData } from 'store/Settings/Tabs/ReportingData';
// import { getDashbordFilterData, setFieldsData } from 'store/DashbordFilter';
// import DashbordFilter from 'store/DashbordFilter';
import { getAdminRolecomponent } from 'store/Settings/Tabs/DahboardManage';
// import { setExtraFilter as setEvaluationExtraFilter } from 'store/EvaluationFilter';
// import { getRoleData } from '../Setting';
// import { getsopdata, getSopViewData } from '../Sopcategory';
// import { getTeamData, getlobdata, getUserdata } from '../Managment';
import { getSopCategory, getSop } from 'store/Settings/Tabs/sopConfig';
import { getLobData, getUsersData, getTeamsData } from 'store/Settings/Tabs/management';
import { getParentFilterData } from 'utils/redux/selectedParentFilter';
import { getEvaluationTeamFeatureData, setFeatureFilter } from 'store/EvaluationFilter';
const apiMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'persist/REHYDRATE':
      if (action?.payload?.rangeDate)
        action.payload.rangeDate = [new Date(action?.payload?.rangeDate[0]), new Date(action?.payload?.rangeDate[1])];
      next(action);
      break;
    case 'scorecardFilter/getLOBData/fulfilled':
      next(action);
      console.log('action.payloadss', action.payload);
      if (action.payload) {
        if (action.payload.length > 0) {
          store.dispatch(handleLobFilterChange({ id: action.payload[0].id, value: true }));
        }
      }
      break;
    case 'scorecardFilter/handleLobFilterChange':
      next(action);
      getTeamList(store, store.getState().filter.selected);
      break;
    case 'scorecardFilter/handleLobAllFilterChange':
      next(action);
      // console.log("filter/handleLobFilterChange", store.getState().filter.selected);
      getTeamList(store, store.getState().filter.selected);
      break;
    case 'scorecardFilter/setSelectedDatafromParent': {
      const finalFilter = getParentFilterData(action.payload, store, 'filter');
      action.payload.parentFilters = finalFilter;
      next(action);
      console.log('scorecardFilter/setSelectedDatafromParent', getParentFilterData(action.payload, store, 'filter'));
      break;
    }
    case 'scorecardFilter/handleTeamFilterChange':
      next(action);
      getAgentList(store, store.getState().filter.selected.LOBTeam);
      store.dispatch(
        getReportingTeamColumnData({
          select_team:
            store
              .getState()
              .filter.selected.LOBTeam?.filter((item) => item?.value === true)
              ?.map((item) => item.id) || []
        })
      );
      break;
    case 'scorecardFilter/handleAllTeamFilterChange':
      next(action);
      store.dispatch(
        getReportingTeamColumnData({
          select_team:
            store
              .getState()
              .filter.selected.LOBTeam?.filter((item) => item?.value === true)
              ?.map((item) => item.id) || []
        })
      );
      getAgentList(store, store.getState().filter.selected.LOBTeam);
      break;
    case 'analyticsfilter/handleLobFilterChange':
      next(action);
      getTeamListAnalytics(store, store.getState().analyticsfilter.selected);
      break;
    case 'callFlow/handleLobFilterChange':
      next(action);
      getTeamListcallFlow(store, store.getState().callFlow.selected);
      break;

    case 'analyticsfilter/handleTeamFilterChange':
      next(action);
      getAgentListAnalytics(store, store.getState().analyticsfilter.selected.LOBTeam);
      break;
    case 'callFlow/handleTeamFilterChange':
      next(action);
      getAgentListCallflow(store, store.getState().callFlow.selected.LOBTeam);
      break;
    case 'analyticsfilter/setSelectedDatafromParent':
      next(action);
      //getTeamListAnalytics() is added to get teams data if lob is selected without applying parent filters
      action.payload.Lob &&
        !store.getState().analyticsfilter?.LOBTeam?.length &&
        getTeamListAnalytics(store, store.getState().analyticsfilter.selected);
      break;
    // case 'dashbord/getDashbordData/fulfilled':
    //   next(action);
    //   store.dispatch(
    //     getDashbordFilterData(
    //       convertdataDashbordfilter(store.getState().dashbord.data, objectToArray, sortByPriorityIndex, store, setFieldsData)
    //     )
    //   );
    //   break;
    // case 'dashbordFilter/getLOBData/fulfilled':
    //   next(action);
    //   console.log('action.payloadss', action.payload);
    //   if (action.payload) {
    //     if (action.payload.length > 0) {
    //       store.dispatch(DashbordFilter.handleLobFilterChange({ id: action.payload[0].id, value: true }));
    //     }
    //   }
    //   break;
    case 'dashbordFilter/handleLobFilterChange':
      // alert('hello');
      next(action);
      getTeamListdashbord(store, store.getState().dashbordFilter.selected);
      break;
    case 'dashbordFilter/handleLobAllFilterChange':
      next(action);

      // console.log("filter/handleLobFilterChange", store.getState().filter.selected);
      getTeamListdashbord(store, store.getState().dashbordFilter.selected);
      break;
    case 'dashbordFilter/handleTeamFilterChange':
      next(action);
      getAgentListdashbord(store, store.getState().dashbordFilter.selected.LOBTeam);
      break;
    case 'dashbordFilter/handleAllTeamFilterChange':
      next(action);
      getAgentListdashbord(store, store.getState().dashbordFilter.selected.LOBTeam);
      break;
    case 'managment/addlobdata/fulfilled':
      next(action);
      store.dispatch(getLobData(getDataFromStore(store)));
      break;
    case 'managment/deletelobdata/fulfilled':
      next(action);
      store.dispatch(getLobData(getDataFromStore(store)));
      break;

    case 'managment/addUserdata/fulfilled':
      next(action);
      store.dispatch(getUsersData(getDataFromUserStore(store)));
      break;

    case 'managment/EditUserdata/fulfilled':
      next(action);
      store.dispatch(getUsersData(getDataFromUserStore(store)));
      break;

    case 'managment/deleteUserdata/fulfilled':
      next(action);

      store.dispatch(getUsersData(getDataFromUserStore(store)));
      break;

    case 'evaluationfilter/setSelectedDatafromParent': {
      const finalFilter = getParentFilterData(action.payload, store, 'evaluationfilter');
      action.payload.parentFilters = finalFilter;
      next(action);
      break;
    }
    case 'evaluationfilter/handleLobFilterChange':
      next(action);

      getTeamListEvalution(store, store.getState().evaluationfilter.selected);
      break;
    case 'evaluationfilter/handleLobAllFilterChange':
      next(action);
      // console.log('"filter/handleLobFilterChange"', store.getState());
      getTeamListEvalution(store, store.getState().evaluationfilter.selected);
      break;
    case 'evaluationfilter/handleTeamFilterChange':
      next(action);
      getAgentListEvalution(store, store.getState().evaluationfilter.selected.LOBTeam);
      if (!action?.payload?.isRedirecting) {
        store.dispatch(
          getEvaluationTeamFeatureData({
            select_team:
              store
                .getState()
                .evaluationfilter.selected.LOBTeam?.filter((item) => item?.value === true)
                ?.map((item) => item.id) || []
          })
        );
      }
      break;
    case 'evaluationfilter/handleAllTeamFilterChange':
      next(action);
      getAgentListEvalution(store, store.getState().evaluationfilter.selected.LOBTeam);
      store.dispatch(
        getEvaluationTeamFeatureData({
          select_team:
            store
              .getState()
              .evaluationfilter.selected.LOBTeam?.filter((item) => item?.value === true)
              ?.map((item) => item.id) || []
        })
      );
      break;
    // case 'analyticsfilter/handleLobFilterChange':
    //   next(action);
    //   getTeamListAnalytics(store, store.getState().analyticsfilter.selected);
    //   break;
    case 'evaluationfilter/getEvaluationTeamFeatureData/fulfilled':
      next(action);
      // getTeamListAnalyze(store, store.getState().analyzefilter.selected);
      // if (store.getState().evaluationfilter.selected.LOBTeam) {
      store.dispatch(setFeatureFilter());
      // }
      break;
    case 'analyzefilter/handleLobFilterChange':
      next(action);
      getTeamListAnalyze(store, store.getState().analyzefilter.selected);
      break;
    case 'analyzefilter/handleLobAllFilterChange':
      next(action);
      // console.log('"filter/handleLobFilterChange"', store.getState());
      getTeamListAnalyze(store, store.getState().analyzefilter.selected);
      break;
    case 'analyzefilter/handleTeamFilterChange':
      next(action);
      getAgentListAnalyze(store, store.getState().analyzefilter.selected.LOBTeam);
      break;
    case 'analyzefilter/handleAllTeamFilterChange':
      next(action);
      getAgentListAnalyze(store, store.getState().analyzefilter.selected.LOBTeam);
      break;

    case 'scorecardFilter/getFilters/fulfilled':
      next(action);
      // console.log('scorecardFilter/getFilters/fulfilled', action.payload);
      if (action.payload) {
        additionalFields(store, action.payload.feature_filter);
      }
      break;

    case 'analyticsfilter/setAllfilterFromParent':
      // action.payload = store.getState().filter;
      if (action.payload) {
        const { isDashboardFilter, agentData } = action.payload;
        if (isDashboardFilter) {
          action.payload = extractData(store.getState().dashbordFilter, [
            'extra_filter',
            'features_filter',
            'LOB',
            'LOBTeam',
            'LOBTeamAgent',
            'rangeDate',
            'fields',
            'selected'
          ]);
          if (agentData && store.getState().analyticsfilter.AnalyticsConfigData) {
            const LOB = agentData?.team?.map((_el) => _el?.lob);
            const UniqueLobs = LOB?.filter((_el, index) => LOB.indexOf(_el) === index);
            action.payload.LOBTeam = getTeamListDataByIds(
              UniqueLobs,
              store.getState().analyticsfilter.AnalyticsConfigData?.select_team?.value
            );
            const LOBTeam = agentData?.team?.map((_el) => _el?.id);
            action.payload.LOBTeamAgent = getAgentListDataByIds(
              LOBTeam,
              store.getState().analyticsfilter.AnalyticsConfigData?.select_agent?.value
            );
          }
        }
      } else {
        action.payload = extractData(store.getState().filter, [
          'extra_filter',
          'features_filter',
          'LOB',
          'LOBTeam',
          'LOBTeamAgent',
          'rangeDate',
          'fields',
          'selected'
        ]);
      }
      next(action);
      break;
    case 'evaluationfilter/setAllfilterFromParent':
      action.payload = extractData(store.getState().analyticsfilter, [
        'extra_filter',
        'features_filter',
        'LOB',
        'LOBTeam',
        'LOBTeamAgent',
        'rangeDate',
        'fields',
        'selected'
      ]);
      // console.log('"evaluationfilter/setAllfilterFromParent"', action.payload);
      next(action);
      break;
    // case 'setting/editrolename/fulfilled':
    //   const object = { search: '', pageindex: 1, totalpage: 10 };
    //   store.dispatch(getRoleData(object));
    //   //  store.dispatch(resetSelectedUser());
    //   // console.log('"evaluationfilter/setAllfilterFromParent"', action.payload);
    //   next(action);
    //   break;
    // case 'setting/addrolename/fulfilled':
    //   const object1 = { search: '', pageindex: 1, totalpage: 10 };
    //   store.dispatch(getRoleData(object1));
    //   //  store.dispatch(resetSelectedUser());
    //   // console.log('"evaluationfilter/setAllfilterFromParent"', action.payload);
    //   next(action);
    //   break;

    case 'sopCategory/addsopdata/fulfilled':
      store.dispatch(getSopCategory(getDataFromCategoryStore(store, 'Category')));
      next(action);
      break;

    // case "sopCategory/editSopData/fulfilled":
    //   store.dispatch(getsopdata(categoryobj));
    //   next(action);
    //   break;
    case 'sopCategory/deleteSopData/fulfilled':
      store.dispatch(getSopCategory(getDataFromCategoryStore(store, 'Category')));
      next(action);
      break;

    case 'sopCategory/addSopViewData/fulfilled':
      store.dispatch(getSop(getDataFromCategoryStore(store, 'view')));
      next(action);
      break;
    case 'sopCategory/deleteSopViewData/fulfilled':
      store.dispatch(getSop(getDataFromCategoryStore(store, 'view')));
      next(action);
      break;

    // case 'setting/deleterolename/fulfilled':
    //   const object2 = { search: '', pageindex: 1, totalpage: 10 };
    //   store.dispatch(getRoleData(object2));

    //   next(action);
    //   break;
    case 'analyzefilter/setAllfilterFromParent':
      action.payload = store.getState().analyzefilter;
      next(action);
      break;
    // case 'evalution/upload/fulfilled':
    //   next(action);
    //   toast.success(action.payload.message);
    //   const abortController = new AbortController();
    //   const filterResult = {
    //     agent_id: [],
    //     call_type: [],
    //     callduration: [],
    //     direction: [],
    //     end_date: null,
    //     exo_phone: [],
    //     fields: [],
    //     filter: {},
    //     index: 0,
    //     lob_id: [],
    //     page_size: 10,
    //     shift: [],
    //     skill_set: [],
    //     start_date: null,
    //     tagging_feature: [],
    //     team_id: [],
    //     tenure: []
    //   };
    //   store.dispatch(getEvalutionsData({ filterResult, signal: abortController.signal }));
    //   break;

    // team
    case 'managment/addTeam/fulfilled':
      next(action);
      store.dispatch(getTeamsData(getDataFromStore(store)));
      break;

    case 'managment/deleteTeamData/fulfilled':
      next(action);
      store.dispatch(getTeamsData(getDataFromStore(store)));
      break;

    case 'feedback/addFeedbackData/fulfilled':
      next(action);
      store.dispatch(getConversationData(store.getState().feedback.id));
      break;

    case 'settingReporting/updateReportingData/fulfilled':
      next(action);
      store.dispatch(getReportingData(store.getState().settingReporting.teamId));
      break;

    case 'notifications/markAsReadNotifications/fulfilled':
    case 'notifications/markAsUnReadNotifications/fulfilled':
    case 'notifications/deletedNotifications/fulfilled':
      next(action);
      store.dispatch(getUnreadNotificationsData(store));
      break;

    case 'DashboardManage/saveGrid/fulfilled':
      next(action);
      store.dispatch(getAdminRolecomponent(store.getState().dashbordmanagement?.SetSelectvalue));
      break;

    case 'auth/logout':
      next(action);
      break;
    default:
      next(action);
      break;
  }
};
export default apiMiddleware;

// const page = store.getState().managment.totalpage;
// const index = store.getState().managment.pageindex;
// const search = "";
// const obj = { search: search, pageindex: index, totalpage: page };

// const userpage = store.getState().managment.Usertotalpage;
// const userindex = store.getState().managment.Userpageindex;
// const usersearch = "";
// const userobj = {
//   search: usersearch,
//   pageindex: userindex,
//   totalpage: userpage,
// };
// console.log(userobj, "objobjobjuser");

// const categorypage = store.getState().sopCategory.totalpage;
// const categoryindex = store.getState().sopCategory.pageindex;
// const pagename = store.getState().sopCategory.pagename;
// const categorysearch = " ";
// const categoryobj = {
//   search: categorysearch,
//   pageindex: categoryindex,
//   totalpage: categorypage,
// };
// const categoryviewobj = {
//   search: categorysearch,
//   pageindex: categoryindex,
//   totalpage: categorypage,
//   name: pagename,
// };
// console.log(categoryobj, "dddfdfffdf");

// const { selectedFilter } = store.getState().filter;

// const selectedRowFilter = {};
// if (selectedFilter) {
//   selectedRowFilter['select_team'] = selectedFilter.LOBTeam?.filter((item) => item?.value === true).map((item) => item.id) || [];
// }

// const usersearch = selectedFilter.LOBTeam?.filter((item) => item?.value === true).map((item) => item.id) || [];
// const userobj = {
//   select_team: usersearch
// };
